<template>
  <BreadCrumb PageTitle="Ajouter Bon d'envoie ( GLOBAL )" />
  <AddGlobalNote />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddGlobalNote from "@/components/Notes/SentNotes/AddGlobalNote.vue";

export default defineComponent({
  name: "AddGlobalNotePage",
  components: {
    BreadCrumb,
    AddGlobalNote,
  },
});
</script>